export default {
  headline: 'Upraviť používateľa',
  permissions: 'Oprávnenia',
  controllerUserMapping: 'Mapovanie používateľov kontroléra',
  role: 'Roly',
  customPermission: 'Vlastné oprávnenia',
  appPermission: 'Oprávnenia aplikácie',
  assetPermission: 'Oprávnenia zariadení',
  firstName: 'Meno',
  lastName: 'Priezvisko',
  email: 'E-mail',
  warningHeadline: 'Stratíte prístup k správe používateľov',
  warningText: 'Práve si zablokujete prístup k správe používateľov. Prístup môžete získať späť iba vtedy, ak vám ho znova udelí iný správca',
};
